import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';

export default class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.currentDate = moment().local().endOf('day');
    this.state = {
      searchText: props.searchText,
      startDate: props.datePickerDisplay.startDate,
      endDate: props.datePickerDisplay.endDate,
      dateRangeFocusedInput: null,
      isHideSearchText: props.isHideSearchText === null || props.isHideSearchText === undefined ? true : props.isHideSearchText
    };
    this.getDate = this.getDate.bind(this);
  }

  getDate() {
    const startDate = this.state.startDate.local().startOf('day');
    const endDate = this.state.endDate.local().endOf('day');
    const searchText = this.state.searchText || '';
    this.props.getDate({
      startDate,
      endDate,
      searchText
    })
  }

  render() {
    return (
      <div style={{ display: 'flex', alignItems: 'stretch', marginBottom: '20px' }}>
        <div hidden={this.state.isHideSearchText}>
          <input type="text" className="form-control" style={{ width: '100%' }} value={this.state.searchText} id="searchText" onChange={event => {
            this.setState({ searchText: event.target.value })
          }} />
        </div>
        <div className="form-group" style={{ display: "inline-block" }}>
          <DateRangePicker
            isOutsideRange={e => e > this.currentDate || e > this.state.startDate + (30 * 1000 * 60 * 60 * 24)}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            focusedInput={this.state.dateRangeFocusedInput}
            onFocusChange={focusedInput => this.setState({ dateRangeFocusedInput: focusedInput })}
            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} />
        </div>
        <button type="button" className="btn btn-primary"
          style={{
            backgroundColor: '#FFE600',
            borderColor: '#7F7E82',
            borderRadius: '3px',
            fontWeight: 600,
            float: 'left',
            height: '34px',
            fontSize: '10px'
          }}
          onClick={this.getDate}>Search
        </button>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// src/components/Forms/ExtendedForms/DatePicker.js